import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { Badge, Button, Drawer, Layout, List, Menu, Modal, Spin, Typography } from 'antd';
import { BellOutlined, UserOutlined } from '@ant-design/icons';
import { logout } from 'redux/actions/user';
import Rest from 'tools/rest';
import UserCard from 'components/user_card';
import { ActionCableConsumer } from '@thrash-industries/react-actioncable-provider';
import { initWebPush } from 'tools/web_push_client';
import './header.css'

const { Header: HeaderAntd } = Layout;
const { Text } = Typography

class Header extends Component {
  state = {
    settingsVisible: this.props.user.pass_is_old,
    visibaleCard: true,
    notificationsVisible: false,
    notifications: [],
    notificationsPage: 1,
    notificationsHasNextPage: true,
    notificationsLoading: false,
    notificationsUnreadCount: 0,
    webPushInitRequested: false,
  }

  componentDidMount() {
    this.loadNotifications({ page: 1, append: false });
  }

  handleLogout = () => {
    Rest.delete('/users/sign_out.json').then(() => {
      this.props.Logout();
    });
  };

  handleOpenSettings = () => {
    this.setState({ settingsVisible: true })
  };

  handleOpenNotifications = () => {
    if (!this.state.webPushInitRequested) {
      this.setState({ webPushInitRequested: true });
      initWebPush();
    }
    this.setState({ notificationsVisible: true }, () => {
      if (this.state.notifications.length === 0) {
        this.loadNotifications({ page: 1, append: false });
      }
    });
  };

  markNotificationRead = (id) => {
    return Rest.patch(`/api/v1/user_notifications/${id}/read.json`)
      .then(() => {
        this.setState((prevState) => {
          let unreadDelta = 0;
          const notifications = prevState.notifications.map((item) => {
            if (item.id !== id) return item;
            if (item.status === 'created') unreadDelta = 1;
            return { ...item, status: 'readed' };
          });
          return {
            notifications,
            notificationsUnreadCount: Math.max(prevState.notificationsUnreadCount - unreadDelta, 0),
          };
        });
      })
      .catch(() => {});
  };

  getNotificationTargetPath = (item) => {
    if (!item || !item.model_type || !item.model_id) {
      return null;
    }

    const modelId = item.model_id;
    const isMobileShell = /^\/m(?:\/|$)/.test(window.location.pathname);

    switch (item.model_type) {
      case 'Request':
        return isMobileShell ? `/m/requests/${modelId}` : `/help_desk?number=${modelId}`;
      case 'Expense':
        return isMobileShell ? `/m/expenses/${modelId}` : `/expense_manager?number=${modelId}`;
      case 'LbAgreement':
        return isMobileShell ? `/m/agreements/${modelId}` : `/agreements?number=${modelId}`;
      case 'TeledomRequest':
        return isMobileShell ? '/m' : `/teledom_requests?number=${modelId}`;
      case 'BlockingService':
        return isMobileShell ? '/m' : `/blocking_services?blocking_number=${modelId}`;
      default:
        return null;
    }
  };

  handleNotificationClick = (item) => {
    const targetPath = this.getNotificationTargetPath(item);
    this.markNotificationRead(item.id).finally(() => {
      if (targetPath) {
        window.open(targetPath, '_blank', 'noopener,noreferrer');
      }
    });
  };

  markAllNotificationsRead = () => {
    Rest.patch('/api/v1/user_notifications/read_all.json')
      .then(() => {
        this.setState((prevState) => ({
          notifications: prevState.notifications.map((item) => ({ ...item, status: 'readed' })),
          notificationsUnreadCount: 0,
        }));
      })
      .catch(() => {});
  };

  loadNotifications = ({ page = 1, append = false } = {}) => {
    if (this.state.notificationsLoading) {
      return;
    }

    this.setState({ notificationsLoading: true });
    Rest.get('/api/v1/user_notifications.json', {
      params: { page, per: 20 },
    })
      .then((response) => {
        const payload = response.data || {};
        const rows = payload.notifications || [];
        const pagination = payload.pagination || {};

        this.setState((prevState) => ({
          notifications: append ? [...prevState.notifications, ...rows] : rows,
          notificationsPage: page,
          notificationsHasNextPage: !!pagination.has_next_page,
          notificationsUnreadCount: payload.unread_count || 0,
          notificationsLoading: false,
        }));
      })
      .catch(() => {
        this.setState({ notificationsLoading: false });
      });
  };

  handleNotificationsScroll = (event) => {
    const target = event.target;
    const nearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 32;
    if (!nearBottom || this.state.notificationsLoading || !this.state.notificationsHasNextPage) {
      return;
    }

    this.loadNotifications({ page: this.state.notificationsPage + 1, append: true });
  };

  handleRealtimeNotification = () => {
    this.loadNotifications({ page: 1, append: false });
  };

  render() {
    const { classes, user } = this.props;
    const {visibaleCard} = this.state
    const auth = !!user;

    return (
      <HeaderAntd className={classes.header} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {auth && (
          <ActionCableConsumer
            channel={{ channel: 'UserNotificationsChannel' }}
            onReceived={this.handleRealtimeNotification}
          />
        )}
        {/* {visibaleCard && user.role != 'engineer' &&
          <Affix style={{ position: 'absolute', top: 80, left: '30%', zIndex: 1, width: '800px' }}>
            <img onClick={()=>{this.setState({visibaleCard: false})}} src="/images/march_v2.png" alt="Сердце CRM" style={{width: '100%'}}/>
          </Affix>
        } */}
        {this.state.settingsVisible &&
          <Modal
            visible={this.state.settingsVisible}
            title={"Настройки аккаунта"}
            onCancel={() => { this.setState({ settingsVisible: false }) }}
            onOk={() => { this.setState({ settingsVisible: false }) }}
            footer={false}
            width={'40%'}
          >
            <UserCard user_id={user.id}/>
          </Modal>
        }
        <Drawer
          open={this.state.notificationsVisible}
          title="Уведомления"
          onClose={() => { this.setState({ notificationsVisible: false }) }}
          width={'25vw'}
          maskClosable={true}
          placement="right"
          extra={
            <Button type="link" onClick={this.markAllNotificationsRead}>
              Прочитать все
            </Button>
          }
          bodyStyle={{ padding: '8px 16px', height: '100%', overflow: 'hidden' }}
        >
          <div onScroll={this.handleNotificationsScroll} style={{ height: '100%', overflowY: 'auto' }}>
            <List
              dataSource={this.state.notifications}
              locale={{ emptyText: 'Нет уведомлений' }}
              renderItem={(item) => (
                <List.Item
                  key={item.id}
                  style={{ cursor: 'pointer', background: item.status === 'created' ? '#fff7e6' : 'transparent' }}
                  onClick={() => this.handleNotificationClick(item)}
                >
                  <List.Item.Meta
                    title={
                      <span style={{ fontWeight: item.status === 'created' ? 600 : 400 }}>
                        {item.title}
                      </span>
                    }
                    description={
                      <div>
                        <div>{item.body}</div>
                        <small style={{ color: '#8c8c8c' }}>
                          {new Date(item.created_at).toLocaleString('ru-RU')}
                        </small>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
            {this.state.notificationsLoading && (
              <div style={{ textAlign: 'center', padding: 12 }}>
                <Spin size="small" />
              </div>
            )}
          </div>
        </Drawer>
        <div className="block">
          <p>Ценность наших услуг несоизмерима с их ценой!</p>
          {/* <p>Мир! Труд! Брют! Дорогие товарищи!</p> */}
          {/* <p>Скурпулёзное занятие делом</p> */}
          {/* <p>🦾 Vivo, vivace!  Живо вджобываем! 😉</p> */}
          {/* <p>🎄 С Новым годом, крошка! 🎄</p> */}
          {/* <p>регламенты и дисциплина — залог успеха!</p> */}
          {/* <p>Не позволяй никому погасить в тебе звезду! ⭐</p> */}
        </div>
        <Text style={{
          // color: "rgb(43, 71, 139)",
          color: 'white',
          margin: 'auto 10px auto 0',
          fontWeight: '500',
          }}>{user.short_name}</Text>
        {auth && (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Button
              type="text"
              onClick={this.handleOpenNotifications}
              style={{ color: 'white', marginRight: 8 }}
              icon={
                <Badge count={this.state.notificationsUnreadCount} size="small" overflowCount={99}>
                  <BellOutlined style={{ fontSize: '24px', color: 'white' }} />
                </Badge>
              }
            />
            <Menu
              mode="horizontal"
              className={classes.menu}
              selectable={false}
              onClick={({ key, domEvent }) => {
                domEvent.preventDefault();
                if (key === 'settings') this.handleOpenSettings();
                if (key === 'logout') this.handleLogout();
              }}
              items={[
                {
                  key: 'user-menu',
                  icon: <UserOutlined style={{ fontSize: '25px', color: 'white' }} />,
                  label: ' ',
                  children: [
                    { key: 'email', label: user.email, disabled: true },
                    { key: 'settings', label: 'Настройки' },
                    { key: 'logout', label: 'Выход' },
                  ],
                },
              ]}
            />
          </div>
        )}
      </HeaderAntd>
    );
  }
}

const styles = (theme) => ({
  header: {
    padding: 0,
    // backgroundColor: '#ED7F6E',
    // backgroundColor: '#dec3be',
    // backgroundColor: '#f9b001',
    backgroundColor: '#ff008c',
  },
  menu: {
    // backgroundColor: '#ED7F6E',
    // backgroundColor: '#dec3be',
    backgroundColor: '#f9b001',
    height: '100%',
    float: 'right',
    // color: 'rgb(43, 71, 139)',
    color: 'white',
  },
});

const mapStateToProps = (state) => {
  return { user: state.user };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Logout(payload) {
      dispatch(logout(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Header)));
